import { render, staticRenderFns } from "./Ybdbj.vue?vue&type=template&id=433233da&scoped=true"
import script from "./Ybdbj.vue?vue&type=script&lang=js"
export * from "./Ybdbj.vue?vue&type=script&lang=js"
import style0 from "./Ybdbj.vue?vue&type=style&index=0&id=433233da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433233da",
  null
  
)

export default component.exports